<div class="container">
  <div class="receiveTrasctionTable">
    <mat-table [dataSource]="dataSource" class="mat-elevation-z8">

      <ng-container matColumnDef="item_id">
        <mat-header-cell *matHeaderCellDef>
          <mat-checkbox *ngIf="isAllSelect === false" (click)="selectAll()" [checked]="isAllSelect">
          </mat-checkbox>
          <mat-checkbox *ngIf="isAllSelect === true" (click)="selectAll()" [checked]="isAllSelect">
          </mat-checkbox>
          <a mat-icon-button *ngIf="selectedRow.length > 0" matTooltip="Delete" (click)="removeSelectedRow()">
            <mat-icon>delete</mat-icon>
          </a>
        </mat-header-cell>
        <mat-cell *matCellDef="let row">
          <mat-checkbox (click)="checkedToggle(row , $event)" [checked]="isAllSelect">
          </mat-checkbox>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="date">
        <mat-header-cell *matHeaderCellDef> Date </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.date}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef> Name </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.name}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="category">
        <mat-header-cell *matHeaderCellDef> Category </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.category}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="account_id">
        <mat-header-cell *matHeaderCellDef> Account </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{accountNames[element.account_id]}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="amount">
        <mat-header-cell *matHeaderCellDef> Amount </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.amount}} </mat-cell>
      </ng-container>


      <mat-header-row *matHeaderRowDef="receiveTrasctionHeaders;"></mat-header-row>
      <mat-row *matRowDef="let row; columns: receiveTrasctionHeaders;"></mat-row>
    </mat-table>
    <br>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/content/common/seven-one/component/receive-amount/receive-amount.component.html